export const SORT_TYPES = {
  text: { asc: 'A \u2192 Z', desc: 'Z \u2192 A' },
  date: { asc: 'Earliest \u2192 Latest', desc: 'Latest \u2192 Earliest' },
  number: { asc: '1 \u2192 9', desc: '9 \u2192 1' },
  currency: { asc: 'Lowest \u2192 Highest', desc: 'Highest \u2192 Lowest' },
};

export const DEPOSITS_COLUMNS = [
  { id: 'event_id', label: 'Event ID', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'number' },
  { id: 'event_name', label: 'Event Name', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'event_status', label: 'Event Status', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'venue_name', label: 'Venue Name', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'event_date', label: 'Event Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'due_date', label: 'Due Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'payment_status', label: 'Payment Status', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'deposit_due', label: 'Deposit Due', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'artist_guarantee', label: 'Artist Guarantee', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
];

export const getDefaultVisibleColumns = () =>
  DEPOSITS_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  DEPOSITS_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
